<!--
 * @Author: your name
 * @Date: 2022-03-13 02:00:12
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-17 14:55:49
 * @Description: file content
-->
<template>
  <div class="top-bar">
    <div class="return-arow" @click="home">
      <img src="@/assets/lottery/arow.png" />
    </div>
    <div
      :class="{
        'table-title': true,
        turntable: isTurntable,
        luckydraw: !isTurntable,
      }"
    ></div>
  </div>
</template>

<script>
  export default {
    // 默认显示大转盘的标题图片
    props: {
      isTurntable: { type: Boolean, default: () => true },
    },
    methods: {
      home() {
        this.$router.push({ path: "/" });
      },
    },
  };
</script>

<style lang="less" scoped>
  // 导入 less 变量
  @import "../var";
  .top-bar {
    display: flex;
    // justify-content: center;
    z-index: 999;
    align-items: center;
    flex: 4;
    box-sizing: border-box;
    padding-top: 5vw;
    width: 100%;
    height: @top-bar-height;

    .return-arow {
      margin-left: 12px;
      flex: 1;
    }

    .turntable {
      background-image: url("~@/assets/lottery/table_title.svg");
    }
    .luckydraw {
      background-image: url("~@/assets/lottery/table_title_luckydraw.svg");
    }
    .table-title {
      flex: 9;
      width: 344px;
      height: @top-bar-height;
      background-size: 377px 40px;
      background-position: 32% 100%;
      background-repeat: no-repeat;
    }
  }
</style>
